<!-- Modal for displaying device information when 'showDeviceModal' is true -->
<app-system-message></app-system-message>

<!-- Modal for selecting a device when 'showMultipleDevicesModal' is true -->
@if (this.modal.showMultipleDevicesModal) {
  <div class="container-fluid">
    <div [ngClass]="theme.getThemeClass(true)" class="modalMultiple col-10">
      <section
        class="modalMultiple2 col-10"
        [ngClass]="theme.getThemeClass(true)"
      >
        <!-- Modal header -->
        <article class="central">
          <div class="header col-12">
            <!-- Display a header message -->
            <h4 class="col-12">
              {{ "iotModalViewSelectDeviceHeader" | translate }}
            </h4>
            <!-- Close button -->
          </div>
          <!-- Container for modal content -->
          <div class="modalContainer2 col-12 selectModal">
            <!-- Selection form for choosing a device -->
            <div class="selectModalRow">
              <label class="verticalCenter" for="selectDevice">{{
                "iotModalViewSelectDevice" | translate
              }}</label>
              <br />
              <!-- Dropdown list for selecting a device -->
              <select
                id="selectDevice"
                [(ngModel)]="selectedDevice"
                class="selectedDeviceList"
              >
                <!-- Display options based on available device names -->
                @for (
                  deviceName of this.modal.selectedMultipleDevicesNames;
                  track deviceName
                ) {
                  <option [value]="deviceName">{{ deviceName }}</option>
                }
              </select>
              <br />
            </div>
          </div>
        </article>
        <nav class="buttonRow">
          <button class="close2 col-6" (click)="this.modal.closeModal()">
            {{ "iotModalButtonClose" | translate }}
          </button>
          <button class="close2Ok col-6" (click)="onOkClick()">
            {{ "iotModalButtonConfirm" | translate }}
          </button>
        </nav>
      </section>
    </div>
  </div>
}

<!-- Section for JSON display of the shadow -->
@if (this.modal.showJsonShadow) {
  <div class="relationship-overlay">
    <section
      [ngClass]="theme.getThemeClass()"
      class="modal col-10 shadow-modal"
    >
      <div class="shadowTitle col-12">
        <h5>{{ "shadow" | translate }} : {{ this.modal.thingName }}</h5>
      </div>
      <textarea
        [ngClass]="theme.getThemeClass()"
        class="textarea col-10"
        [value]="this.modal.convertShadowToJson()"
        readonly
      ></textarea>
      <button class="close col-6" (click)="closeModal()">
        {{ "iotModalButtonClose" | translate }}
      </button>
    </section>
  </div>
}

<!-- Section for the relationship modal -->
@if (this.modal.showRelationship) {
  <div class="relationship-overlay">
    <section
      [ngClass]="theme.getThemeClass()"
      class="modal col-10 relationship-modal"
    >
      <h4 class="device-association-title">
        {{ "deviceRelationship" | translate }}
      </h4>
      <article class="device-association-article col-12">
        <div class="col-10 device-association">
          <div class="association-field">
            <h5 class="association-sub-title">
              {{ "iotModalViewDeviceName" | translate }}
            </h5>
            <!-- Section for the device name -->
            <label class="association-label">
              {{ this.modal.thingName }}
            </label>
          </div>
          <!-- Section for distributor association -->
          <div class="association-field">
            <h5 class="association-sub-title">
              {{ "distributorAssociated" | translate }}
            </h5>
            @if (!this.changeAssociationClicked) {
              <label class="association-label">
                {{
                  this.distributorLegalName ||
                    ("noDistributorAssociated" | translate)
                }}
              </label>
            }
            <div class="association-select-div">
              @if (changeAssociationClicked) {
                <select
                  [(ngModel)]="this.distributor_id"
                  class="form-control col-8 ng-select"
                >
                  @for (
                    distributor of modal.distributorsArray;
                    track distributor.distributor_id
                  ) {
                    <option [value]="distributor.distributor_id">
                      {{ distributor.legal_name }}
                    </option>
                  }
                </select>
              }
            </div>
          </div>

          <!-- Section for client association label and select when changing association -->
          <div class="association-field">
            <h5 class="association-sub-title">
              {{ "clientAssociated" | translate }}
            </h5>
            @if (!this.changeAssociationClicked) {
              <label class="association-label">
                {{ this.clientLegalname || ("noClientAssociated" | translate) }}
              </label>
            }
            <div class="association-select-div">
              @if (changeAssociationClicked) {
                <select
                  [(ngModel)]="this.client_id"
                  (ngModelChange)="clientSelectChange()"
                  class="form-control col-8 ng-select"
                >
                  @for (client of modal.clientsArray; track client.client_id) {
                    <option [value]="client.client_id">
                      {{ client.legal_name }}
                    </option>
                  }
                </select>
              }
            </div>
          </div>
          <!-- Section for bin association label and select when changing association -->
          <div class="association-field">
            <h5 class="association-sub-title">
              {{ "binAssociated" | translate }}
            </h5>

            @if (!this.changeAssociationClicked) {
              <label class="association-label">
                {{ this.binName || ("noBinAssociated" | translate) }}
              </label>
            }
            <div class="association-select-div">
              @if (changeAssociationClicked) {
                <select
                  [(ngModel)]="this.bin_id"
                  class="form-control col-8 ng-select"
                  [ngClass]="{ 'has-value': selectedBin }"
                >
                  @for (bin of modal.binArray; track bin.bin_id) {
                    <option [value]="bin.bin_id">{{ bin.bin_name }}</option>
                  }
                </select>
              }
              <!-- <app-custom-multi-select [(ngModel)]="this.bin_id"
            class="form-control col-8 ng-select" [ngClass]="{'has-value': selectedBin }" [options]="modal.binArray" bindLabel="bin_name" bindValue="bin_id"></app-custom-multi-select>
           -->
            </div>
          </div>

          <!-- Section for billable flag -->
          <div class="association-field">
            <h5 class="association-sub-title">
              {{ "billable" | translate }}
            </h5>
            @if (!this.changeAssociationClicked) {
              <label class="association-label">
                {{
                  this.billableFlag ? ("yes" | translate) : ("no" | translate)
                }}
              </label>
            }
            <div class="association-select-div">
              @if (changeAssociationClicked) {
                <label class="association-label">
                  <input type="checkbox" [(ngModel)]="this.billableFlag" />
                </label>
              }
            </div>
          </div>
        </div>
      </article>
      <nav class="col-6">
        @if (!this.changeAssociationClicked) {
          <button
            [ngClass]="theme.getThemeClass()"
            class="btn-device close col-6"
            (click)="closeDeviceRelationModal()"
          >
            {{ "iotModalButtonClose" | translate }}
          </button>
        }
        @if (this.changeAssociationClicked) {
          <button
            [ngClass]="theme.getThemeClass()"
            class="btn-device close col-6"
            (click)="this.changeAssociationClicked = false"
          >
            {{ "userEditButtonLabelReturn" | translate }}
          </button>
          <button
            [ngClass]="theme.getThemeClass()"
            class="btn-device change-association col-6"
            (click)="saveDeviceAssociation()"
          >
            {{ "save" | translate }}
          </button>
        }
        @if (!this.changeAssociationClicked) {
          <button
            [ngClass]="theme.getThemeClass()"
            class="btn-device change-association col-6"
            (click)="this.changeAssociationClicked = true"
          >
            {{ "changeAssociation" | translate }}
          </button>
        }
      </nav>
    </section>
  </div>
}

<!-- Section for the deletion of a device -->
@if (this.iotService.showDeleteThing) {
  <div class="relationship-overlay">
    <section [ngClass]="theme.getThemeClass()" class="delete-modal col-10">
      <label>{{ "deleteThingQuestionPart1" | translate }}</label>
      <div class="div-input-thing-name">
        <input
          class="form-control thing-name-input"
          type="text"
          [(ngModel)]="this.iotService.desiredDeleteThingName"
          #inputThingName
        />
      </div>
      <nav class="nav-delete-thing">
        <button
          [ngClass]="theme.getThemeClass()"
          class="btn btn-delete-thing"
          (click)="
            this.modal.showDeviceModal = false;
            this.iotService.showDeleteThing = false
          "
        >
          {{ "iotModalButtonClose" | translate }}
        </button>
        <button
          [ngClass]="theme.getThemeClass()"
          class="btn btn-delete-thing"
          (click)="this.iotService.confirmDeleteThing()"
        >
          {{ "usereditFormLabelConfirm" | translate }}
        </button>
      </nav>
    </section>
  </div>
}

<!-- Section for deleting data of a device -->
@if (this.iotService.showDeleteDataThing) {
  <div class="relationship-overlay">
    <section
      [ngClass]="theme.getThemeClass()"
      class="delete-modal col-10 delete-data-modal"
    >
      <label>{{ "deleteThingQuestionPart1" | translate }}</label>
      <div class="div-input-thing-name">
        <input
          class="form-control thing-name-input"
          type="text"
          [(ngModel)]="this.iotService.desiredDeleteThingName"
          #inputThingName
        />
      </div>
      <div class="card-title mt-0 status-thing-delete">
        <label class="switch">
          <input
            type="checkbox"
            id="checkboxShadowDelete"
            (change)="deleteReferencesChange()"
          />
          <span class="slider round"></span>
        </label>
        <label class="toggle-thing-delete">{{
          "deleteReferences" | translate
        }}</label>
      </div>
      <div class="card-title mt-0 status-thing-delete">
        <label class="switch">
          <input
            type="checkbox"
            id="checkboxLogsDelete"
            (change)="deleteLogsChange()"
          />
          <span class="slider round"></span>
        </label>
        <label class="toggle-thing-delete">{{
          "deleteLogs" | translate
        }}</label>
      </div>
      <div class="card-title mt-0 status-thing-delete">
        <label class="switch">
          <input
            type="checkbox"
            id="checkboxReportDataDelete"
            (change)="deleteReportDatasChange()"
          />
          <span class="slider round"></span>
        </label>
        <label class="toggle-thing-delete">{{
          "deleteReportData" | translate
        }}</label>
      </div>
      <nav class="nav-delete-thing">
        <button
          [ngClass]="theme.getThemeClass()"
          class="btn btn-delete-thing"
          (click)="
            this.modal.showDeviceModal = false;
            this.iotService.showDeleteDataThing = false
          "
        >
          {{ "iotModalButtonClose" | translate }}
        </button>
        <button
          [ngClass]="theme.getThemeClass()"
          class="btn btn-delete-thing"
          (click)="
            this.iotService.confirmDeleteDataThing();
            this.modal.showDeviceModal = false
          "
        >
          {{ "usereditFormLabelConfirm" | translate }}
        </button>
      </nav>
    </section>
  </div>
}

<!-- Section for read and write notes for the device -->
@if (this.modal.showNotesModal) {
  <div class="relationship-overlay">
    <section
      [ngClass]="theme.getThemeClass()"
      class="device-notes-modal col-10 notes-modal"
    >
      <h5 class="device-note-title">{{ "deviceNotes" | translate }}</h5>
      <div class="notes-list">
        @if (this.modal.showLoadingStatus) {
          <app-loading-element
            class="container-fluido componentBelow"
          ></app-loading-element>
        }
        <ul>
          @for (note of this.modal.deviceNotes; track note.created) {
            <li
              class="notes-li"
              (dblclick)="editDeviceNote(note); this.isDeviceNoteUpdate = true"
            >
              <span class="note-created-by">
                {{ note.given_name }} {{ note.family_name }}
              </span>
              <pre class="pre-note">{{ decodeNoteText(note.note) }}</pre>
              <div class="note-modified-date">
                {{ convertTimestamp(note.created) }}
              </div>
            </li>
            <hr class="hr-notes" />
          }
        </ul>
      </div>
      <div class="div-device-note-input">
        <textarea
          class="form-control thing-name-input"
          type="text"
          [(ngModel)]="this.modal.newNote"
          #inputDeviceNote
          (input)="calculateCharacterLeft(this.modal.newNote)"
          maxlength="500"
        ></textarea>
      </div>
      <div class="div-device-note-lenght-left">
        <label class="label-device-note-lenght-left">
          {{ "character" | translate }} :
        </label>
        <label class="number-device-note-lenght-left">
          {{ characterLeft }}
        </label>
      </div>
      <nav class="nav-delete-thing">
        <button
          [ngClass]="theme.getThemeClass()"
          class="btn btn-delete-thing"
          (click)="this.closeModal(); this.modal.newNote = ''"
        >
          {{ "iotModalButtonClose" | translate }}
        </button>
        @if (!isDeviceNoteUpdate) {
          <button
            [ngClass]="theme.getThemeClass()"
            class="btn btn-delete-thing"
            (click)="this.saveNotes()"
          >
            {{ "loginFNewPasswordBtnConfirmNewPw" | translate }}
          </button>
        } @else {
          <button
            [ngClass]="theme.getThemeClass()"
            class="btn btn-delete-thing"
            (click)="this.modal.updateNote(); this.isDeviceNoteUpdate = false"
          >
            {{ "loginFNewPasswordBtnConfirmNewPw" | translate }}
          </button>
        }
      </nav>
    </section>
  </div>
}

<!-- Production status modal -->
@if (this.modal.showProdStatusModal) {
  <section
    [ngClass]="theme.getThemeClass()"
    class="modal col-10 section_prod_status"
  >
    <h3>{{ "deviceProductionStatus" | translate }}</h3>
    <h4>{{ this.modal.thingName }}</h4>
    <h5>{{ "currentDeviceProdStatus" | translate }}</h5>
    <select
      class="form-control prod_status_select"
      [(ngModel)]="selectedProdStatusIndex"
    >
      <option value="">{{ "select" | translate }}</option>
      @for (status of iotService.ProductionStatus; track status.key) {
        <option [value]="status.key">{{ status.value | translate }}</option>
      }
    </select>
    <nav>
      <button
        [ngClass]="theme.getThemeClass()"
        class="btn btn-delete-thing"
        (click)="this.closeModal()"
      >
        {{ "iotModalButtonClose" | translate }}
      </button>
      <button
        [ngClass]="theme.getThemeClass()"
        class="btn btn-delete-thing"
        (click)="this.saveProdStatus(); this.closeModal()"
      >
        {{ "usereditFormLabelConfirm" | translate }}
      </button>
    </nav>
  </section>
}
